import * as dimensions from "./dimensions";
import * as fontWeights from "./fontWeights";
import { StyleSheet } from "aphrodite/no-important";

export const baseFontStyle = {
	fontFamily: ["proximasoft", "serif"],
	fontSize: 16,
	fontStyle: "normal",
	fontWeight: fontWeights.REGULAR,
	lineHeight: 1.3,
};

export default StyleSheet.create({
	baseFont: {
		fontFamily: ["proximasoft", "serif"],
		fontStyle: "normal",
		fontWeight: fontWeights.REGULAR,
		fontSize: 16,
		lineHeight: 1.3,
	},
	/* NOTE: baseFontNotImportant is a duplicate of the above baseFont, but it doesn't add !important to the styles.
		This exists bc somehow, aphrodite is changing any uses of baseFont to always include !important.
		- The main theory behind this is somewhere, something is using appStyles.baseFont w/ regular aphrodite
		  (not no-important) and this is causing all uses of baseFont to use !important. Confirming/fixing this
		  would require going through and changing all uses of appStyles.baseFont, which is a major overhaul and
		  requires extensive testing, so this is a workaround solution.
	*/
	baseFontNotImportant: { ...baseFontStyle },
	lightFont: {
		fontFamily: ["proximasoft", "serif"],
		fontStyle: "normal",
		fontWeight: fontWeights.THIN,
		fontSize: 16,
	},
	flexRow: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "flex-start",
		alignItems: "center",
	},
	flexColumn: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-start",
		alignItems: "stretch",
	},
	horizontalScrollContainer: {
		overflowX: "auto",
		width: "auto",
	},
	link: {
		textDecoration: "none",
	},
	pointer: {
		cursor: "pointer",
	},
	buttonText: {
		...baseFontStyle,
		position: "relative",
		paddingLeft: 16,
		paddingRight: 16,
		verticalAlign: "middle",
		letterSpacing: 0,
		textTransform: "uppercase",
		fontWeight: fontWeights.MEDIUM,
		fontSize: 14,
		textAlign: "center",
	},
	docketPage: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-start",
		alignItems: "stretch",
		marginTop: dimensions.headerHeight,
		marginBottom: dimensions.footerHeight,
		height: `calc(100vh - ${dimensions.headerHeight + dimensions.footerHeight}px)`,
	},
	megaMenuHeaderPage: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-start",
		alignItems: "stretch",
		height: `calc(100vh - ${dimensions.megaMenuHeaderHeight + dimensions.footerHeight}px)`,
	},
});
